import articuloXListaPrecioService from '../../../services/articuloXListaPrecioService';
import { resolverPrecioDesdeLista } from '../../../utils/precioListaPedido';
import type { ProductoInfo360Maestro } from './components/ArticuloInfo360Header';

export interface PreciosListaMinMax {
  minNeto: number | null;
  maxNeto: number | null;
  cantidadListas: number;
}

export async function fetchPreciosMinMaxLista(
  producto: ProductoInfo360Maestro,
): Promise<PreciosListaMinMax> {
  const codigoArticulo = producto.codigoArticulo?.trim();
  if (!codigoArticulo) {
    return { minNeto: null, maxNeto: null, cantidadListas: 0 };
  }

  try {
    const result = await articuloXListaPrecioService.getArticuloXListaPrecios({
      codigoArticulo,
      pageNumber: 1,
      pageSize: 200,
    });

    const precios: number[] = [];
    for (const item of result.items ?? []) {
      const res = resolverPrecioDesdeLista(producto, item);
      if (res.tipo !== 'sinPrecio' && res.precioLista > 0) {
        precios.push(res.precioLista);
      }
    }

    if (precios.length === 0) {
      return { minNeto: null, maxNeto: null, cantidadListas: 0 };
    }

    return {
      minNeto: Math.min(...precios),
      maxNeto: Math.max(...precios),
      cantidadListas: precios.length,
    };
  } catch {
    return { minNeto: null, maxNeto: null, cantidadListas: 0 };
  }
}
